(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ddd-vin-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  const validVin = value => /^[A-HJ-NPR-Z0-9]{17}$/.test(value.trim().toUpperCase());
  const invalidCartLine = () => Array.from(document.querySelectorAll('[data-ddd-cart-vin]')).find(line => !validVin(line.dataset.dddCartVin));
  const stop = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  const validateForm = (form, event) => {
    const input = form?.querySelector('[data-ddd-vin]');
    if (!input) return true;
    input.value = input.value.trim().toUpperCase();
    const valid = validVin(input.value);
    input.setCustomValidity(valid ? '' : input.dataset.error);
    input.setAttribute('aria-invalid', String(!valid));
    if (!valid) {
      stop(event);
      input.scrollIntoView({ block: 'center' });
      input.focus({ preventScroll: true });
      input.reportValidity();
    }
    return valid;
  };
  const blockCheckout = event => {
    const line = invalidCartLine();
    if (!line) return;
    stop(event);
    line.hidden = false;
    line.scrollIntoView({ block: 'center' });
    line.focus({ preventScroll: true });
  };
  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const add = target?.closest('[data-atc-form], button[name="add"], button[type="submit"], input[type="submit"]');
    if (add?.form && !validateForm(add.form, event)) return;
    if (target?.closest('[name="checkout"], [href*="/checkout"], [data-checkout], [data-cart-checkout]')) blockCheckout(event);
  }, true);
  window.addEventListener('submit', event => {
    if (!validateForm(event.target, event)) return;
    const form = event.target;
    if (form instanceof HTMLFormElement && (form.action.includes('/checkout') || event.submitter?.name === 'checkout')) blockCheckout(event);
  }, true);
  window.addEventListener('input', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-ddd-vin]')) return;
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');
  }, true);
  const refreshCart = () => document.documentElement.classList.toggle('ddd-cart-needs-vin', Boolean(invalidCartLine()));
  const start = () => {
    refreshCart();
    new MutationObserver(refreshCart).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
